import { render } from "./vue-countTo.vue?vue&type=template&id=2a55d8e8"
import script from "./vue-countTo.vue?vue&type=script&lang=js"
export * from "./vue-countTo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__